import {
  PROJECT_LINK_PERMISSION_TYPE,
  PROJECT_SHARE_TYPE,
} from '@components/App/Modal/Share/components/Access/components/ShareOptions/types'
import { createReducer } from '@reduxjs/toolkit'
import { metaActions } from '@store/reducers/manager/meta/actions'
import type { ProjectMeta } from '@store/reducers/manager/meta/types'

import { type Member, type Member as MemberModel, ProjectOrigin } from '@/types'

export const initialProjectMetaStore: ProjectMeta = {
  id: null,
  space: {
    id: '',
    features: [],
    // Unknown until the space call answers: assume a canvas, so a guest or a
    // failed call still opens the editor the way it does today.
    type: 'sitemap',
    workspaces: [],
  },
  anonymous_comments: false,

  access: {
    canView: true,
    accessBlockerType: null,
    canComment: false,
    canEdit: true,
    canEditContent: false,
  },

  ownerId: null,
  ownerPlan: null,

  //@todo delete
  team: null,

  members: [],
  recipients: [],
  subscribers: [],

  avatars: [],
  avatar: null,
  customAvatar: null,

  integrations: {
    figma: false,
    ga4: false,
  },

  origin: ProjectOrigin.ORDINARY,
  template: false,

  shareType: PROJECT_SHARE_TYPE.ANYONE,
  linkPermission: PROJECT_LINK_PERMISSION_TYPE.VIEW,
  password: false,

  createdAt: new Date().toISOString(),
  updatedAt: null,
  legacyBlocksContent: false,
}

export const projectMetaReducer = createReducer<ProjectMeta>(
  initialProjectMetaStore,
  (builder) =>
    builder
      .addCase(metaActions.updateMeta, (state, action) => {
        return {
          ...state,
          // @TODO review this and fix
          ...action.payload,
        }
      })
      .addCase(metaActions.updateAccess, (state, action) => {
        return {
          ...state,
          access: {
            ...state.access,
            ...action.payload,
          },
        }
      })
      .addCase(metaActions.updateAvatar, (state, action) => {
        return {
          ...state,
          avatar: action.payload.avatar,
        }
      })
      .addCase(
        metaActions.updateUpdatedAt,
        (state, { payload: { updatedAt } }) => {
          return {
            ...state,
            updatedAt,
          }
        }
      )
      .addCase(metaActions.addMember, (state, action) => {
        return {
          ...state,
          members: [...state.members, action.payload],
        }
      })
      .addCase(metaActions.deleteMember, (state, action) => {
        return {
          ...state,
          members: state.members.filter(
            (member) => member.id !== action.payload
          ),
        }
      })
      .addCase(metaActions.updateMembers, (state, action) => {
        return {
          ...state,
          members: action.payload,
        }
      })
      .addCase(metaActions.updateMemberPermission, (state, action) => {
        const { memberId, permission } = action.payload

        const members = state.members.map((member) => {
          if (member.id === memberId) {
            return {
              ...member,
              permission,
            }
          }

          return member
        }) as Member[]

        return {
          ...state,
          members,
        }
      })
      .addCase(metaActions.addRecipient, (state, { payload }) => ({
        ...state,
        recipients: [...state.recipients, payload],
      }))
      .addCase(metaActions.deleteMemberInvitation, (state, action) => {
        const { ownerId } = state

        const members = state.members
          .filter((member) => member.id !== action.payload)
          .sort((member: MemberModel) => {
            return !(ownerId && member.id === ownerId) ? 1 : -1
          })

        return {
          ...state,
          members,
        }
      })
      .addCase(metaActions.setSpace, (state, action) => {
        return {
          ...state,
          space: action.payload,
        }
      })
)
